/**
 * 行政区域页面路径
 */
export const REGION_PAGE_PATH = '/region'
